export default __webpack_public_path__ + "static/media/Bed, White.5dd7acb1.png";